import request from "@utils/request";

/**
 * 根据所选的品牌名称返回分类id
 * @param name
 * @returns {*}
 */
export function returnCateIdByName(name){
    return request.post("/sys/image/category/returnCategoryNodeId",name);
}

/**
 * 点击tab按键切换商品属性
 * @param id
 * @returns {*}
 */
export function  showProductAttr(id){
    return request.get("/eb/store/product/showProductAttr?id="+id);
}

/**
 * 更新商品详情
 * @param param
 * @returns {*}
 */
export function updateProductDesc(param){
    return request.post("/eb/store/product/updateProductDesc",param);
}

/**
 * 保存商品属性
 * @param param
 * @returns {*}
 */
export function saveProductSaleAttr(param){
    return request.post("/eb/store/product/saveProductSaleAttr",param);
}

/**
 * 商品-限时特惠--左侧（搜索商品名称或者货号，参加活动的是否隐藏）
 * @param param
 * @returns {*}
 */
export function getProductsByKeyword(param) {
    return request.post("/eb/store/product/getProductsByKeyword",param);
}

/**
 *
 * @param id
 * @returns {*}
 */
export function getDiscountProducts(id){
    return request.post("/eb/store/product/discount/product/getDiscountProducts?id="+id);
}

/**
 * 加入特惠
 * @param param
 * @returns {*}
 */
export function addDiscountProduct(param){
    return request.post("/eb/store/product/discount/product/addDiscountProduct",param);
}

/**
 * 暂停活动商品
 * @param id
 * @returns {*}
 */
export function stopDiscountProduct(id){
    return request.post("/eb/store/product/discount/product/stopDiscountProduct?id="+id);
}

/**
 * 退出活动商品
 * @param id
 * @returns {*}
 */
export function exitDiscountProduct(id){
    return request.post("/eb/store/product/discount/product/exitDiscountProduct?id="+id);
}

/**
 * 更新单个折扣和特惠价
 * @param data
 * @returns {*}
 */
export function updateDiscountProductsPrice(data){
    return request.post("/eb/store/product/discount/product/updateDiscountProductsPrice",data);
}

/**
 * 更新多个折扣和优惠券
 * @param data
 * @returns {*}
 */
export function updateMultDiscountProductsPrice(data){
    return request.post("/eb/store/product/discount/product/updateMultDiscountProductsPrice",data);
}

/**
 * 是否参加活动
 * @param data
 * @returns {*}
 */
export function saveIsActiveData(data){
    return request.post("/eb/store/product/discount/product/saveIsActiveData",data);
}

/**
 * 逻辑移除折扣商品
 * @param id
 * @returns {*}
 */
export function deleteLogicDiscountProduct(id){
    return request.get("/eb/store/product/discount/product/deleteLogicDiscountProduct?id="+id);
}

/**
 * 批量更新
 * @param ids
 * @returns {*}
 */
export function batchSaveIsActiveData(ids){
    return request.get("/eb/store/product/discount/product/batchSaveIsActiveData?ids="+ids);
}

/**
 * 跟微信小程序共用一个方法
 * @param orderCode
 * @returns {*}
 */
export function viewLogical(orderCode){
    return request.get("/api/express/viewLogical?orderId="+orderCode);
}